import { EduResourcesTab } from "@/edu-resources";

/** Search-only synonyms for each Resources tab. */
export const RESOURCES_TAB_KEYWORDS: Record<EduResourcesTab, string[]> = {
  [EduResourcesTab.Folder]: ["folders", "collections", "groups"],
  [EduResourcesTab.Resources]: ["library", "articles", "handouts", "files"],
  [EduResourcesTab.AutoSend]: ["automatic", "schedule", "rules"],
};
